































import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// components
import { Select2 } from '@/components/form'

// models
import { AreaModel } from '@/models/config'

// services
import { AreaService } from '@/services/config'
import { PropOptionSelect } from '@/models'

export default defineComponent({
  name: 'HeaderFormSelectArea',
  components: {
    Select2
  },
  props: {
    v: {
      type: Object,
      required: true
    },
    sizeColumn: {
      type: Number,
      default: 12
    }
  },
  setup (props) {
    const areas: Ref<AreaModel[]> = ref([])
    const getAreas = async () => {
        areas.value = await AreaService.getActivated()
    }
    getAreas()

    const areasOp: Ref<PropOptionSelect[]> = computed(() => {
      return areas.value.map(area => ({
        value: area.id ?? null,
        text: area.name
      }))
    })

    const subAreasOP: Ref<PropOptionSelect[]> = computed(() => {
      if (props.v.areaSelectedId.$model) {
        const area = areas.value.find(area => Number(area.id) === Number(props.v.areaSelectedId.$model))
        if (area) {
          return area?.subAreas && area.subAreas.length > 0 ? area.subAreas.map(area => ({
              value: area.id ?? null,
              text: area.name
          })) : []
        }
      }
      return []
    })

    return {
      areasOp,
      subAreasOP
    }
  }
})
